import * as React from 'react';
import { BaSeTheme } from '../../theme';
import { TypeTransitionProps } from './stepper-styled';

export const useStepperTransition = (
  currentStep: number,
  withTransition: boolean,
): TypeTransitionProps => {
  const previousStep = React.useRef(currentStep);
  const [transition, setTransition] =
    React.useState<TypeTransitionProps>('inert');

  React.useEffect(() => {
    const fromStep = previousStep.current;
    previousStep.current = currentStep;
    setTransition('inert');

    if (!withTransition || fromStep === currentStep) {
      return undefined;
    }

    const nextTransition =
      fromStep < currentStep ? 'leftToRight' : 'rightToLeft';
    let finishTimer: ReturnType<typeof setTimeout> | undefined;
    const startTimer = setTimeout(() => {
      setTransition(nextTransition);
      finishTimer = setTimeout(
        () => setTransition('inert'),
        BaSeTheme.transitions.durationNormalInMilliseconds,
      );
    }, 0);

    return () => {
      clearTimeout(startTimer);
      if (finishTimer !== undefined) {
        clearTimeout(finishTimer);
      }
    };
  }, [currentStep, withTransition]);

  return transition;
};
